import React, { useEffect, useRef, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Proparties_modal from "../../components/modal/proparties_modal";
import { useDispatch, useSelector } from "react-redux";
import { showPropatiesModal, walletModalShow } from "../../redux/counterSlice";
import Meta from "../../components/Meta";
import { addNotification } from "../../components/Notification";
import Image from "next/image";
import SimpleReactValidator from "simple-react-validator";
import DynamicDropdown from "../../components/dropdown/customDropdown";
import requestHandler from "../../redux/httpClient";
import MySpinner from "../../components/spinner";
import { fetchCategory } from "../../redux/getCategory";
import { fetchCollections } from "../../redux/getCollections";
import { fetchArtifacts } from "../../redux/getArtifacts";
import { useRouter } from "next/router";
import { useMetaMask } from "metamask-react";
import { deployContract } from "../../context/deployContract";

const Create = () => {
  const fileTypes = [
    "JPG",
    "PNG",
    "GIF",
    "SVG",
    "MP4",
    "WEBM",
    "MP3",
    "WAV",
    "OGG",
    "GLB",
    "GLTF",
  ];
  const [file, setFile] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState("");
  const [categoryText, setCategoryText] = useState("Select a value");
  const [categoryValue, setCategoryValue] = useState("");
  const [collectionText, setCollectionText] = useState("Select a value");
  const [collectionValue, setCollectionValue] = useState("");
  const [price, setPrice] = useState("");
  const [categoryOptions, setCategoryOptions] = useState();
  const [collectionOptions, setCollectionOptions] = useState();
  const [inputFields, setInputFields] = useState([{ name: '', type: '', trait: '' }]);
  const [loading, setLoading] = useState(false);
  const { categoryData } = useSelector(state => state.getCategory);
  const { data } = useSelector(state => state.getCollections);
  const router = useRouter();
  const dispatch = useDispatch();
  const { status, connect, account, chainId, ethereum } = useMetaMask();

  useEffect(() => {
    if (categoryData?.length === 0) {
      dispatch(fetchCategory());
    }
    if (data?.length === 0) {
      dispatch(fetchCollections());
    }
  }, []);

  useEffect(() => {
    getCollectionHandler();
  }, [account]);

  const handleCategoryData = (option) => {
    // setCategoryOption(option);
    setCategoryText(option.value);
    setCategoryValue(option.id);
  };

  const handleCollectionData = (option) => {
    // setCollectionOption(option);
    setCollectionText(option.value);
    setCollectionValue(option.id);
  };

  const getCollectionHandler = async () => {
    setLoading(true);
    let data = {
      walletAddress: account,
    };
    try {
      const getCollectionPayload = await requestHandler("collection/allCollectionList", "post", data);
      setLoading(false);
      let newArr = getCollectionPayload?.data?.data?.map((x) => {
        return {
          label: x.name,
          value: x.name,
          id: x.id,
        }
      });
      setCollectionText(newArr[0]?.label);
      setCollectionValue(newArr[0]?.id);
      setCollectionOptions(newArr);
    }
    catch (e) {
      setLoading(false);
    };
  };

  const popupItemData = [
    {
      id: 1,
      name: "Traits",
      text: "Traits describe attributes of your item. They appear as filters inside your collection page and are also listed out inside your item page",
      icon: "proparties-icon",
    },
  ];

  useEffect(() => {
    if (categoryData) {
      let newArr = categoryData?.map((x) => {
        return {
          label: x.name,
          value: x.name,
          id: x.id,
        }
      });
      setCategoryText(newArr[0]?.label);
      setCategoryValue(newArr[0]?.id);
      setCategoryOptions(newArr);
    }
  }, [categoryData]);

  // useEffect(() => {
  //   if (data) {
  //     let newArr = data?.map((x) => {
  //       return {
  //         label: x.name,
  //         value: x.name,
  //         id: x.id,
  //       }
  //     });
  //     setCollectionText(newArr[0]?.label);
  //     setCollectionValue(newArr[0]?.id);
  //     setCollectionOptions(newArr);
  //   }
  // }, [data]);

  const createNftHandler = async () => {
    setLoading(true);
    try {
      if (typeof window.ethereum === 'undefined') {
        const metaMaskUrl = 'https://metamask.io/download.html';
        if (window.confirm('MetaMask is not installed. Would you like to install it?')) {
          window.open(metaMaskUrl, '_blank');
          setLoading(false);
        }
        return;
      }
      else if (status !== "connected") {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        if (accounts.length === 0) {
          if (window.confirm('MetaMask is not connected. Would you like to connect it?')) {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
          } else {
            setLoading(false);
            return;
          }
        }
        setLoading(false);
      }
      else {
        let data = {
          name: name,
          image: file,
          description: description,
          price: price,
          collectionId: collectionValue,
          metadata: JSON.stringify(inputFields),
          walletAddress: account,
        };
        try {
          const createNftPayload = await requestHandler("artifact/artifactCreate", "post", data, "jwt_token", "file");
          setLoading(false);
          if (createNftPayload?.status === 200) {
            addNotification({
              title: "Success",
              message: createNftPayload?.data?.message,
              type: "success",
            });
            router.push("/");
            dispatch(fetchArtifacts());
          }
        } catch (error) {
          setLoading(false);
        }
      }
    }
    catch (error) {
      setLoading(false);
    }
  };

  // const createNftHandler = async () => {
  //   setLoading(true);
  //   try {
  //     if (status === 'notInstalled' || status === 'unavailable') {
  //       const metaMaskUrl = 'https://metamask.io/download.html';
  //       if (window.confirm('MetaMask is not installed. Would you like to install it?')) {
  //         window.open(metaMaskUrl, '_blank');
  //         setLoading(false);
  //       }
  //     }
  //     else {
  //       await handleConnect();
  //       if (status === 'connected') {
  //         const deployedContract = await deployContract();
  //         console.log("deployedContract", deployedContract.target);

  //         if (deployedContract && !deployedContract.code) {
  //           let data = {
  //             name: name,
  //             image: file,
  //             description: description,
  //             price: price,
  //             collectionId: collectionValue,
  //             metadata: JSON.stringify(inputFields),
  //             walletAddress: account,
  //           };
  //           const createNftPayload = await requestHandler("artifact/artifactCreate", "post", data, "jwt_token", "file");
  //           setLoading(false);
  //           if (createNftPayload?.status === 200) {
  //             addNotification({
  //               title: "Success",
  //               message: createNftPayload?.data?.message,
  //               type: "success",
  //             });
  //             router.push("/");
  //             dispatch(fetchArtifacts());
  //           }
  //         }
  //       }
  //     }
  //   }
  //   catch (error) {
  //     setLoading(false);
  //   }
  // };

  return (
    <div>
      {loading && <MySpinner />}
      <Meta title="Create NFT" />
      <section className="relative py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="container">
          <h1 className="font-display text-jacarta-700 py-16 text-center text-4xl font-medium dark:text-white">
            Create NFT
          </h1>
          <div className="mx-auto max-w-[48.125rem]">
            <div className="mb-6">
              <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                Image
                <span className="text-red">*</span>
              </label>
              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 group relative flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed bg-white py-20 px-5 text-center">
                <div className="relative z-10 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-500 mb-4 inline-block dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                  </svg>
                </div>
                <div className="dark:bg-jacarta-600 bg-jacarta-50 absolute inset-4 cursor-pointer rounded opacity-0 group-hover:opacity-100 ">
                  <input
                    type="file"
                    onChange={(e) => {
                      setFile(e.target.files[0])
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-name"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Name
                <span className="text-red">*</span>
              </label>
              <input
                type="text"
                id="item-name"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Item name"
                required
                name="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                onBlur={() => { simpleValidator.current.showMessageFor("name"); }}
              />
            </div>
            <span className="text-red">
              {simpleValidator.current.message("name", name, "required")}
            </span>
            <div className="relative">
              <div>
                <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                  Collection
                </label>
                <div className="mb-3 flex items-center space-x-2">
                  <p className="dark:text-jacarta-300 text-2xs">
                    This is the collection where your item will appear.
                    <Tippy
                      theme="tomato-theme"
                      content={
                        <span>
                          Moving items to a different collection may take up to
                          30 minutes.
                        </span>
                      }
                    >
                      <span className="inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          className="dark:fill-jacarta-300 fill-jacarta-500 ml-1 -mb-[3px] h-4 w-4"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"></path>
                        </svg>
                      </span>
                    </Tippy>
                  </p>
                </div>
              </div>
              <div className="dropdown my-1 cursor-pointer">
                <DynamicDropdown
                  options={collectionOptions}
                  onSelect={handleCollectionData}
                  text={collectionText}
                />
              </div>
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-description"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Description
              </label>
              <p className="dark:text-jacarta-300 text-2xs mb-3">
                The description will be included on the item's detail page underneath its image. Markdown syntax is supported.
              </p>
              <textarea
                id="item-description"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                rows="4"
                required
                placeholder="Provide a detailed description of your item."
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                name="description"
                onBlur={() => { simpleValidator.current.showMessageFor("description"); }}
              ></textarea>
            </div>
            <span className="text-red">
              {simpleValidator.current.message("description", description, "required")}
            </span>
            {/* <div className="relative">
              <div>
                <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                  Category
                </label>
              </div>
              <div className="dropdown my-1 cursor-pointer">
                <DynamicDropdown
                  options={categoryOptions}
                  onSelect={handleCategoryData}
                  text={categoryText}
                />
              </div>
            </div> */}
            {popupItemData.map(({ id, name, text, icon }) => {
              return (
                <div
                  key={id}
                  className="dark:border-jacarta-600 border-jacarta-100 relative border-b py-6"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex">
                      <svg className="icon fill-jacarta-700 mr-2 mt-px h-4 w-4 shrink-0 dark:fill-white">
                        <use xlinkHref={`/icons.svg#icon-${icon}`}></use>
                      </svg>

                      <div>
                        <label className="font-display text-jacarta-700 block dark:text-white">
                          {name}
                        </label>
                        <p className="dark:text-jacarta-300">{text}</p>
                      </div>
                    </div>
                    <button
                      className="group dark:bg-jacarta-700 hover:bg-accent border-accent flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border bg-white hover:border-transparent"
                      onClick={() => dispatch(showPropatiesModal())}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="fill-accent group-hover:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
                      </svg>
                    </button>
                  </div>
                </div>
              );
            })}
            <Proparties_modal
              inputFields={inputFields}
              setInputFields={setInputFields}
            />
            <div className="mb-6">
              <label
                htmlFor="item-external-link"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Price
              </label>
              <input
                type="url"
                id="item-external-link"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Please enter the price"
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
                name="price"
                onBlur={() => { simpleValidator.current.showMessageFor("price") }}
              />
            </div>
            <span className="text-red">
              {simpleValidator.current.message("price", price, "required")}
            </span>
            {/* <div className="relative">
              <div>
                <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                  Network
                </label>
              </div>
              <div className="dropdown my-1 cursor-pointer">
                <DynamicDropdown
                  options={networkOptions}
                  onSelect={handleBlockchainData}
                  text={blockchainText}
                />
              </div>
            </div> */}
            <button
              onClick={(e) => {
                e.preventDefault();
                if (simpleValidator.current.allValid()) {
                  if (file) {
                    // if (collectionText !== "Select a value" && categoryText != "Select a value" && blockchainText !== "Select a value") {
                    createNftHandler();
                    // }
                    // else {
                    //   addNotification({
                    //     title: "Alert",
                    //     message: "You need to select collection, category and blockchain to create an nft.",
                    //     type: "danger",
                    //   });
                    // }
                  }
                  else {
                    addNotification({
                      title: "Alert",
                      message: "Please select an image.",
                      type: "danger",
                    });
                  }
                }
                else {
                  simpleValidator.current.showMessages();
                  forceUpdate(1);
                }
              }}
              className="bg-accent-dark cursor-pointer rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
            >
              Create
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Create;
